"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SideContent;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SideContent(_ref) {
  var _currentConfig$SideCo, _currentConfig$SideCo2, _currentConfig$SideCo3;
  var {
    currentConfig,
    customSideContent,
    isForcedSingleColumnLayout,
    secondaryStyle
  } = _ref;
  var conditionalCardPadding = isForcedSingleColumnLayout ? 'no-horizontal-padding' : '';
  var additionalSideContentClass = isForcedSingleColumnLayout ? '' : 'fullWidth';
  var columnClass = isForcedSingleColumnLayout ? 'col-12' : 'col-md-4 right-col';
  var additionalClass = secondaryStyle ? ' alternate' : '';
  columnClass += additionalClass;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: columnClass
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sideContent ".concat(additionalSideContentClass)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card full-height".concat(secondaryStyle ? ' card--flat' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body custom-card-padding ".concat(conditionalCardPadding)
  }, customSideContent ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, customSideContent) : null, (currentConfig === null || currentConfig === void 0 || (_currentConfig$SideCo = currentConfig.SideContent) === null || _currentConfig$SideCo === void 0 ? void 0 : _currentConfig$SideCo.Title) && /*#__PURE__*/_react.default.createElement("h3", null, (0, _htmlReactParser.default)(currentConfig.SideContent.Title)), (currentConfig === null || currentConfig === void 0 || (_currentConfig$SideCo2 = currentConfig.SideContent) === null || _currentConfig$SideCo2 === void 0 ? void 0 : _currentConfig$SideCo2.Description) && /*#__PURE__*/_react.default.createElement("p", null, (0, _htmlReactParser.default)(currentConfig.SideContent.Description)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, currentConfig === null || currentConfig === void 0 || (_currentConfig$SideCo3 = currentConfig.SideContent) === null || _currentConfig$SideCo3 === void 0 || (_currentConfig$SideCo3 = _currentConfig$SideCo3.CTAList) === null || _currentConfig$SideCo3 === void 0 ? void 0 : _currentConfig$SideCo3.map((cta, index) => {
    var result = (cta === null || cta === void 0 ? void 0 : cta.Label) && /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
      className: "customLeftPaddingTablet",
      href: cta === null || cta === void 0 ? void 0 : cta.Href,
      target: (cta === null || cta === void 0 ? void 0 : cta.Target) || null,
      variant: (cta === null || cta === void 0 ? void 0 : cta.Variant) || 'link'
    }, (0, _htmlReactParser.default)(cta === null || cta === void 0 ? void 0 : cta.Label)));
    return result;
  }))))));
}